import { Injectable } from '@angular/core';
import { ThemeConfig } from '../../../appconfig';
import { DomSanitizer, Title } from '@angular/platform-browser';

@Injectable({
  providedIn: 'root'
})
export class ThemeService {
  currentTheme!: ThemeConfig;
  constructor(private sanitizer: DomSanitizer, private titleService: Title) { }


  applyTheme(theme: ThemeConfig) {
    const root = document.documentElement;

    Object.entries(theme).forEach(([key, value]) => {
      if (key === 'logoUrl') {
        //if logo available then set it as css variable
        //if not then remove the variable
        if (value)
          root.style.setProperty('--logoUrl', `url("data:image/png;base64,${value}")')`);
        else
          root.style.removeProperty('--logoUrl');
      } else if (key.toLowerCase() === 'organizationname') {
        //if organization name available then set it as css variable
        this.titleService.setTitle(value);
      }
      else {
        root.style.setProperty(`--${key}`, value);
      }
    });
    this.currentTheme = theme;
  }

  getTheme(): ThemeConfig {
    if (!this.currentTheme) {
      const storedTheme = localStorage.getItem('theme');
      if (storedTheme) {
        this.currentTheme = JSON.parse(storedTheme);
        this.applyTheme(this.currentTheme); // Apply again in case of reload
      }
    }
    return this.currentTheme;
  }
}


